import AuthService from "./authService.js";
import ApolloShopCopierHistoryItem from "../Domain/ApolloShopCopierHistoryItem";
import SearchParams from "../Elements/SearchParams";
import ApolloShopCopierSearchParams from "../Contents/RoverImport/ApolloShopCopier/ApolloShopCopierSearchParams";

export default class ApolloShopCopierService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const searchParams = new SearchParams(searchItem, ApolloShopCopierSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `/api/ApolloShopCopier/GetAllBySearchingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new ApolloShopCopierHistoryItem(item));
    }

    return [];
  }

  static DuplicateShop(item) {
    const authService = AuthService.getInstance();
    let url = `/api/ApolloShopCopier/DuplicateShop?idlist=${item.Id}`;
    if (item.ShopperId) url += `&shopperid=${item.ShopperId}`;
    if (item.Status) url += `&status=${item.Status}`;

    return authService.CallBackendFunction(url);
  }
}
